const getWordCount = (content: string) => {
  const words = content.split(' ')

  return words.length
}

export const timeToRead = (content: string) => {
  const words = getWordCount(content)
  let timeToRead = 0
  const avgWPM = 265

  timeToRead = Math.round(words / avgWPM)

  if (timeToRead === 0) {
    timeToRead = 1
  }

  return timeToRead
}
